import React, { Component } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

type Props = {
	pdfFile: string;
}

class PDFComponent extends Component<Props> {
	loadErr = (e: Error) => {
		console.log('Error while loading document! ', e.message);
	}

	onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
		// TODO: Handle document load success
	}

	render() {
		return (
			<Document
				file={this.props.pdfFile} 
				onLoadError={this.loadErr} 
				onLoadSuccess={this.onDocumentLoadSuccess}
			>
				<Page pageNumber={1} renderTextLayer={false} renderAnnotationLayer={false} />
			</Document>
		)
	}
}

export default PDFComponent;
